export default __webpack_public_path__ + "static/media/escrita.05539c43.ico";